$(function() {

$(".staff-slider").slick({
    centerMode: true,
    centerPadding: '50px',
    slidesToShow: 1,
    arrows: false,
    mobileFirst: true,
    responsive: [
    {
        breakpoint: 576,
        settings: {
        slidesToShow: 3,
        centerPadding: false,
        }
    }
  ]
});
        
        });